module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--auth main--login"
  }, [_c('div', {
    staticClass: "gradient-bg"
  }), _vm._v(" "), _c('ui-auth', {
    attrs: {
      "slug": "login",
      "submit": "Sign In"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe01037a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/Login.vue
// module id = 314
// module chunks = 0